import en from '../en/navigation'

const cz: typeof en = {
  search: 'Vyhledávání',
  iconclass: 'Iconclass',
  explore: 'Témata',
  vise: 'Vise',
  exhibitions: 'Výstavy',
  project: 'Projekt',
  team_and_partners: 'Team & Partneři',
  contact: 'Kontakt',
  help: 'Nápověda',
  help_link: 'https://e-ilustrace.cz/napoveda/',
  close: 'Zavřít',
  login: 'Přihlásit se',
  login_page: 'Přihlášení',
  registration: 'Registrace',
  register: 'Registrovat se',
  email: 'E-mailová adresa',
  recovery_email: 'Zadejte e-mailovou adresu',
  recovery_email_sent: 'Email s obnovou hesla byl úspěšně odeslán',
  password_change: 'Změna hesla',
  old_password: 'Staré heslo',
  new_password: 'Nové heslo',
  do_password_change: 'Změnit heslo',
  password_reset: 'Změna hesla',
  password_changed: 'Heslo bylo úspěšně změněno',
  password: 'Heslo',
  repeated_password: 'Zopakované heslo',
  name: 'Jméno',
  surname: 'Příjmení',
  remember_login: 'Zapamatovat přihlášení',
  forgot_password: 'Zapomněli jste heslo?',
  accept_terms: 'Souhlasím s',
  accept_terms_link_name: ' podmínkami',
  accept_terms_link: 'https://e-ilustrace.cz/podminky-registrace/',
  password_recovery: 'Obnova hesla',
  recovery_link: 'Zašlete mi odkaz na obnovu hesla',
  recovered: 'Obnoveno',
  recovered_text:
    'Pokud účet existuje, bude vám zaslán e-mail s dalšími instrukcemi',
  field_is_required: 'Vyplňte prosím toto pole',
  bad_email_format: 'Nesprávný formát emailu',
  accepted_terms_required:
    'Pro dokončení registrace musíte souhlasit s podmínkami',
  bad_repeated_password: 'Hesla se neshodují',
  registration_successful:
    'Registrace proběhla úspěšně, nyní prosím potvrďte svůj email',
  registration_activation_successful:
    'Aktivace účtu proběhla úspěšně, nyní se můžete přihlásit',
  status_logged_in: 'Přihlášen',
  status_logged_out: 'Nepřihlášen',
  status_checking: 'Načítání',
  citations_info: 'Pravidla citací',
  citations_title: 'Zásady pro užívání',
  citations_intro:
    'Vstupem do databáze e-ilustrace se uživatel zavazuje odkázat na její využití ve všech výstupech.',
  citations_recommendation:
    'Při citování doporučujeme uvádět zdroj v následující formě:',
  citations_database_reference:
    'e-ilustrace.cz [online databáze]. Praha: Knihovna AV ČR, v. v. i., [cit. rrrr-mm-dd]. Dostupné z: https://e-ilustrace.cz/.',
  citations_specific_record_title: 'Konkrétní záznam v databázi:',
  citations_specific_reference:
    'e-ilustrace.cz [online databáze], INC035_IL010. [cit. rrrr-mm-dd]. Dostupné z: https://app.e-ilustrace.cz/record-detail/2c44d885-1408-47e5-8cac-768e01b3720e/switch?back=search.',
  citations_note:
    'Pozn.: Pokud citujete jiný záznam, nahraďte číslo záznamu a URL příslušnými údaji ze záznamu.',
  citations_accept: 'Souhlasím',
}

export default cz
